import { createContext, useContext, useEffect, useState } from "react";

const LanguageContext = createContext({ lang: "en", setLang: () => {} });

const STORAGE_KEY = "sybrax-lang";

const getInitialLang = () => {
    if (typeof window === "undefined") return "en";
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored === "en" || stored === "tr") return stored;
    } catch (_) {
        // ignore
    }
    return "en";
};

export const LanguageProvider = ({ children }) => {
    const [lang, setLangState] = useState(getInitialLang);

    useEffect(() => {
        if (typeof document !== "undefined") {
            document.documentElement.lang = lang;
        }
        try {
            localStorage.setItem(STORAGE_KEY, lang);
        } catch (_) {
            // ignore
        }
    }, [lang]);

    const setLang = (l) => setLangState(l === "tr" ? "tr" : "en");

    return (
        <LanguageContext.Provider value={{ lang, setLang }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => useContext(LanguageContext);
